export const inventoryOptions = [
    { id: 1, name: "Više lokacija" },
    { id: null, name: "Jedna lokacija" },
];

export const regax = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

// Indicates that the form creates a new value
export const NEW = "new";

export const queryKeys = {
    page: "page",
    sort: "redosled",
    limit: "prikaz",
    search: "search",
};
